import Dialog from '@zenbusiness/zui/Dialog';
import DialogContent from '@zenbusiness/zui/DialogContent';
import IconButton from '@zenbusiness/zui/IconButton';
import PropTypes from 'prop-types';

import CloseIcon from '@mui/icons-material/Close';

import BoAModalContent from './BoAModalContent';

const BoAModal = ({ isOpen, handleClose }) => (
  <Dialog
    fullScreen={false}
    maxWidth="md"
    onClose={handleClose}
    open={isOpen}
  >
    <IconButton
      aria-label="close"
      onClick={handleClose}
      sx={{
        position: 'absolute',
        right: 4,
        top: 4
      }}
    >
      <CloseIcon />
    </IconButton>
    <DialogContent>
      <BoAModalContent />
    </DialogContent>
  </Dialog>
);

BoAModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default BoAModal;
